/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { pluginPostbackChangeOrderRequestSchema } from "./pluginPostbackChangeOrderRequestSchema.ts";

export const callbackPluginCancelOrderCreateStatus200Schema = z.any();

export const callbackPluginCancelOrderCreateResponseSchema = callbackPluginCancelOrderCreateStatus200Schema;

export const callbackPluginCancelOrderCreateDataSchemaJson = pluginPostbackChangeOrderRequestSchema;

export const callbackPluginCancelOrderCreateDataSchemaXml = pluginPostbackChangeOrderRequestSchema;

export const callbackPluginCancelOrderCreateDataSchema = z.union([callbackPluginCancelOrderCreateDataSchemaJson, callbackPluginCancelOrderCreateDataSchemaXml]);
